import BaseComponent from "../baseComponent.js";
import styles from "./terms-and-conditions.scss";

export default class VerifyEmail extends BaseComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    var target = $(".privacy-content");
    target.scroll(function () {
      var scrollHeight = target.get(0).scrollHeight;
      var sHeight = target.scrollTop() + target.height();
      if (sHeight === scrollHeight) {
        $(".agree-btn").removeClass("disabled").addClass("agree-btn--activated");
      }
    });

    this.$modal = $("#verify-email");
    this.$modal.modal({
      dismissible: false
    });
  }

  show() {
    let email = " " + this.props.getUserEmail();
    $(this.refs.email).text(email);
    this.$modal.modal("open");
  }

  hide() {
    this.$modal.modal("close");
  }

  render() {
    return (
      <div id="verify-email" className="modal" style={{maxHeight: "100%"}}>
        <div className="modal-content">
          <div className="header" style={{borderBottom: 0}}>
            <div className="title">Verify your email address</div>
            <div className="agree" style={{marginBottom: "18px"}}>We sent an email to
              <span ref="email" style={{color: "#336192"}}></span> to make
              sure you own it. Please check your email for the instructions on how to confirm your account.
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/auth/verifyEmail.jsx